import { createTheme } from '@mui/material';

import { colors } from '@constants/colorConstants';
import { nunitoSans } from '@constants/fonts';

export const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.darkBlue,
    },
    text: {
      primary: colors.typographyNero,
    },
    error: {
      main: colors.red,
    },
  },
  typography: {
    allVariants: {
      fontFamily: nunitoSans.style.fontFamily,
      letterSpacing: 'normal',
      fontWeight: 300,
      fontSize: 18,
      lineHeight: '28px',
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: '3px',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          fontSize: '16px',
          backgroundColor: '#d4d6e0',
          borderBottom: '1px  #fff',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '18px',
          fontWeight: 700,
          lineHeight: '28px',
          padding: '10px 30px',
          color: colors.typographyNero,

          ':hover': {
            color: colors.darkBlue,
            transition: '0.2s',
            borderBottom: `${colors.darkBlue} 2px`,
          },

          '&.Mui-selected': {
            color: colors.darkBlue,
            fontWeight: 700,
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-child(even)': {
            backgroundColor: colors.tableGrey,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px 6px',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          borderBottomColor: colors.charcoalTint80,

          '&:first-child': {
            paddingLeft: '12px',
          },
          '&:last-child': {
            paddingRight: '12px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white,
          lineHeight: '28px',

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.typographySpace,
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: colors.typographySpace,
          },
          '&.Mui-error': {
            backgroundColor: colors.palePink,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '14px 16px',
          lineHeight: '28px',
          height: '28px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: {
          color: colors.charcoal,
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: (props) => {
          const { ownerState } = props;
          return (
            ownerState.disableUnderline && {
              maxHeight:
                ownerState.multiline && ownerState.maxRows
                  ? `${Number(ownerState.maxRows) * 72}px`
                  : '72px',
              minWidth: '400px',
              padding: '8px',
              border: `1px solid ${ownerState.disabled ? colors.darkGrey : colors.darkBlue}`,
              color: colors.black,
              backgroundColor: ownerState.disabled ? colors.disabledGrey : colors.white,
              borderRadius: '4px',
              ':hover': {
                outline: !ownerState.disabled && `2px solid ${colors.darkBlue}`,
              },
            }
          );
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          marginBottom: '5px',
          color: colors.black,
          fontSize: '24px',
          fontWeight: '500',
        },
      },
    },
  },
});
